export default __webpack_public_path__ + "static/media/categories.67f72437.yaml";